module.exports = __webpack_public_path__ + "static/media/Stephanie Smith Headshot.dd90e104.jpeg";